import { createAction, props } from '@ngrx/store';
import { Vehicle } from '../../../features/vehicles/domain/vehicle.model';
import * as ActionTypes from './vehicle.actionTypes';

export const loadVehicle = createAction(ActionTypes.LOAD_VEHICLE, props<{ vehicle: Vehicle }>());
